module.exports = __webpack_public_path__ + "static/media/2015-OAC-Logo-RGB.62a90584.png";